import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

export default class LocationTree extends React.Component {

    state = {
        open: false
    };

    // Fix for IE11
    findIndex = (locations) => {
        var index = -1;
        for (var i = 0; i < locations.length; ++i) {
            if (locations[i].id === this.state.selected) {
                index = i;
                break;
            }
        }
        return index;
    }

    // Fix for IE11
    findItem = (nodes) => {
        for (var i = 0; i < nodes.length; ++i) {
            if (nodes[i].id === this.state.selected) {
                return nodes[i];
            }
        }
        return null;
    }

    handleOpen = () => {
        this.setState({...this.state, open: true});
    };

    handleClose = () => {
        this.setState({...this.state, open: false, selected: -1});
    };

    handleAddClose = () => {
        if (this.state.selected 
            && this.state.selected !== -1 
            && this.findIndex(this.props.formData.locations) === -1) {
            this.props.handleClose(this.findItem(this.state.nodes));
        }
        this.setState({...this.state, open: false}, this.handleClose);
    };

    handleOnClick = (id)=>{
        if(this.state.selected === id){
            this.setState({...this.state, selected: -1});
        } else {
            this.setState({...this.state, selected: id});
        }
    };

    handleChange = (event, index, value)=>{
        this.setState({...this.state, selectedServer: value});
        this.props.onServerChanged(value);
    };

    flatter = (node, parentDepth, out) => {
        node.depth = parentDepth + 20;
        out.push(node);
        (node.nodes || []).filter(n=>!n.customerId).map(n=>this.flatter(n, node.depth, out))
    };

    componentWillReceiveProps(nextProps) {
        if(!nextProps.nodes)
            return;

        let flatNodeList = [];
        this.flatter(nextProps.nodes, -20, flatNodeList);
        //flatNodeList = flatNodeList.filter(node=>node.customerId?false:true);

        this.setState({
            ...this.state,
            nodes: flatNodeList,
            selected: -1
        });
    }

    render() {
        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.handleClose}
            />,
            <FlatButton
                label="Add"
                primary={true}
                keyboardFocused={true}
                onTouchTap={() => {
                    this.handleAddClose()
                    this.handleClose()
                }
                }
            />,
        ];

        return (
            <div>
                <RaisedButton label="Link CashControl Nodes" onTouchTap={this.handleOpen} />
                <Dialog
                    title="Link CashControl Nodes"
                    modal={false}
                    open={this.state.open}
                    autoScrollBodyContent={true}
                    actions={actions}
                    onRequestClose={this.handleClose}
                >
                    <div>
                        <SelectField floatingLabelText="Server" value={this.state.selectedServer}
                                     onChange={this.handleChange}>
                            {(this.props.servers || []).map(server =>
                                <MenuItem key={server.id} value={server.id} primaryText={server.name} />)}
                        </SelectField>

                        {(this.state.nodes || []).filter(node=>node.type !=='DEVICE').map(node=>
                            <div 
                                key={node.id} 
                                style={{height: "25px", cursor: node.childSelected ? 'not-allowed' : 'pointer',background: node.id === this.state.selected?'#eeeeee':'', padding: "4px"}}
                            >
                                <div onClick={()=> { if (!node.childSelected) {
                                    this.handleOnClick(node.id)
                                    }}} style={{height: "25px",  marginLeft: node.depth + "px"}}>
                                    {node.name}
                                </div>
                            </div>
                        )
                        }
                    </div>

                </Dialog>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/customerForm/LocationTree.js